interface AppointmentStatesInput {
  planned: number;
  documented: number;
  noReport: number;
  didNotTakePlace: number;
}

export default class AppointmentStates {
  constructor(
    public readonly planned: number,
    public readonly documented: number,
    public readonly noReport: number,
    public readonly didNotTakePlace: number,
  ) {}

  static fromGraphql(data: AppointmentStatesInput): AppointmentStates {
    return new AppointmentStates(data.planned, data.documented, data.noReport, data.didNotTakePlace);
  }

  get total(): number {
    return this.planned + this.documented + this.noReport + this.didNotTakePlace;
  }
}
